import React from "react";
import { Popover, PopoverTrigger, PopoverContent, Button, Box, useDisclosure, useClipboard } from "@chakra-ui/react";
import { useColorTheme } from "contexts/color-theme";
import { textStyles } from "theme/text-styles";
import { Logo } from "components/brand/logo";
import { trackEvent, trackMutinyConversion } from "lib/analytics";
import { CheckIcon, ClipboardIcon, DownloadIcon, MegaphoneIcon } from "ui/icons";
import { Link } from "ui/link";
import { hightouchLogosZip, hightouchLogoSvg } from "../../constants/brand-assets";

const POPOVER_ITEM_STYLES = {
  ...textStyles.caption1,
  display: "flex",
  alignItems: "center",
  borderRadius: "base",
  fontWeight: "normal",
  gap: "smallest",
  justifyContent: "start",
  p: "smallest",
  transition: "background-color .15s ease",
  _hover: {
    bg: "brand.backgroundSecondary.light",
  },
};

export function LogoPopover() {
  const { theme } = useColorTheme();
  const { isOpen, onToggle, onClose } = useDisclosure();
  const { onCopy, hasCopied } = useClipboard(hightouchLogoSvg);

  return (
    <Popover offset={[32, 12]} isOpen={isOpen} onClose={onClose}>
      <PopoverTrigger>
        <Link
          href="/"
          aria-label="Hightouch."
          onContextMenu={(event) => {
            event.preventDefault();
            onToggle();
          }}
        >
          <Logo theme={theme} width={150} />
        </Link>
      </PopoverTrigger>

      <PopoverContent
        border="1px"
        borderColor="brand.border.light"
        borderRadius="base"
        color="brand.text.light"
        w="220px"
        p="tinier"
      >
        <Button
          variant="unstyled"
          sx={POPOVER_ITEM_STYLES}
          onClick={() => {
            onCopy();
            trackEvent("Brand Logo Copied");
          }}
        >
          <Box as={hasCopied ? CheckIcon : ClipboardIcon} boxSize="smaller" color="brand.textSecondary.light" />
          {hasCopied ? "Copied .SVG" : "Copy .SVG"}
        </Button>

        <Link
          href={hightouchLogosZip}
          sx={POPOVER_ITEM_STYLES}
          onClick={() => {
            trackEvent("Brand Assets Downloaded");
            trackMutinyConversion("asset-downloaded");
          }}
        >
          <DownloadIcon boxSize="smaller" color="brand.textSecondary.light" />
          Brand assets
        </Link>

        <Link href="/press" sx={POPOVER_ITEM_STYLES}>
          <MegaphoneIcon boxSize="smaller" color="brand.textSecondary.light" />
          Press
        </Link>
      </PopoverContent>
    </Popover>
  );
}
